import script from "./UserAutomatchReferral.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAutomatchReferral.vue?vue&type=script&setup=true&lang=ts"

import "./UserAutomatchReferral.vue?vue&type=style&index=0&id=e519a592&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e519a592"]])

export default __exports__